/**
 * Polkista themes (Figma). Applied via className + CSS vars in App.css.
 * Backend `template` → theme id: TEMPLATE_ID_TO_THEME.
 */

export const POLKISTA_THEMES = [
    {
        id: "azul",
        label: "Azul",
        className: "theme-azul",
        swatch: "#015c97",
        colors: {
            primary: "#015c97",
            primaryLight: "#015c97",
            primaryMid: "#0e4467",
            primaryDark: "#002741",
        },
    },
    {
        id: "verde",
        label: "Verde",
        className: "theme-verde",
        swatch: "#5fab74",
        colors: {
            primary: "#5fab74",
            primaryLight: "#5fab74",
            primaryMid: "#40784e",
            primaryDark: "#2f5a3c",
        },
    },
    {
        id: "naranja",
        label: "Naranja",
        className: "theme-naranja",
        swatch: "#db8a4d",
        colors: {
            primary: "#db8a4d",
            primaryLight: "#db8a4d",
            primaryMid: "#b3582f",
            primaryDark: "#934524",
        },
    },
    {
        id: "naranja-quemado",
        label: "Naranja quemado",
        className: "theme-naranja-quemado",
        swatch: "#c2410c",
        colors: {
            primary: "#c2410c",
            primaryLight: "#c2410c",
            primaryMid: "#7c2d12",
            primaryDark: "#431407",
        },
    },
    {
        id: "verde-bosque",
        label: "Verde bosque",
        className: "theme-verde-bosque",
        swatch: "#166534",
        colors: {
            primary: "#166534",
            primaryLight: "#166534",
            primaryMid: "#0f3d26",
            primaryDark: "#052e16",
        },
    },
    {
        id: "petroleo",
        label: "Petróleo",
        className: "theme-petroleo",
        swatch: "#155e75",
        colors: {
            primary: "#155e75",
            primaryLight: "#155e75",
            primaryMid: "#0f3b4c",
            primaryDark: "#082f49",
        },
    },
    {
        id: "azul-marino",
        label: "Azul marino",
        className: "theme-azul-marino",
        swatch: "#1e3a8a",
        colors: {
            primary: "#1e3a8a",
            primaryLight: "#1e3a8a",
            primaryMid: "#172554",
            primaryDark: "#0b1120",
        },
    },
    {
        id: "bronce",
        label: "Bronce",
        className: "theme-bronce",
        swatch: "#a68768",
        colors: {
            primary: "#a68768",
            primaryLight: "#a68768",
            primaryMid: "#6b5947",
            primaryDark: "#42382e",
        },
    },
    {
        id: "ambar",
        label: "Ámbar",
        className: "theme-ambar",
        swatch: "#b45309",
        colors: {
            primary: "#b45309",
            primaryLight: "#b45309",
            primaryMid: "#78350f",
            primaryDark: "#451a03",
        },
    },
    {
        id: "terracota",
        label: "Terracota",
        className: "theme-terracota",
        swatch: "#a9442d",
        colors: {
            primary: "#a9442d",
            primaryLight: "#a9442d",
            primaryMid: "#6b271d",
            primaryDark: "#3f1711",
        },
    },
    {
        id: "bordo",
        label: "Bordó",
        className: "theme-bordo",
        swatch: "#9f1239",
        colors: {
            primary: "#9f1239",
            primaryLight: "#9f1239",
            primaryMid: "#701a3c",
            primaryDark: "#4c0519",
        },
    },
    {
        id: "fucsia",
        label: "Fucsia",
        className: "theme-fucsia",
        swatch: "#ec4899",
        colors: {
            primary: "#ec4899",
            primaryLight: "#ec4899",
            primaryMid: "#9d174d",
            primaryDark: "#500724",
        },
    },
    {
        id: "rojo-clasico",
        label: "Rojo clásico",
        className: "theme-rojo-clasico",
        swatch: "#b91c1c",
        colors: {
            primary: "#b91c1c",
            primaryLight: "#b91c1c",
            primaryMid: "#7f1d1d",
            primaryDark: "#450a0a",
        },
    },
    {
        id: "lima",
        label: "Lima",
        className: "theme-lima",
        swatch: "#84cc16",
        colors: {
            primary: "#84cc16",
            primaryLight: "#84cc16",
            primaryMid: "#3f6212",
            primaryDark: "#1a2e05",
        },
    },
    {
        id: "violeta",
        label: "Violeta",
        className: "theme-violeta",
        swatch: "#8b5cf6",
        colors: {
            primary: "#8b5cf6",
            primaryLight: "#8b5cf6",
            primaryMid: "#4c1d95",
            primaryDark: "#2e1065",
        },
    },
    {
        id: "turquesa",
        label: "Turquesa",
        className: "theme-turquesa",
        swatch: "#14b8a6",
        colors: {
            primary: "#14b8a6",
            primaryLight: "#14b8a6",
            primaryMid: "#115e59",
            primaryDark: "#042f2e",
        },
    },
    {
        id: "coral",
        label: "Coral",
        className: "theme-coral",
        swatch: "#f97360",
        colors: {
            primary: "#f97360",
            primaryLight: "#f97360",
            primaryMid: "#9f1239",
            primaryDark: "#4c0519",
        },
    },
    {
        id: "marron-cafe",
        label: "Marrón café",
        className: "theme-marron-cafe",
        swatch: "#6f4e37",
        colors: {
            primary: "#6f4e37",
            primaryLight: "#6f4e37",
            primaryMid: "#422a1d",
            primaryDark: "#26150d",
        },
    },
    {
        id: "negro-grafito",
        label: "Negro grafito",
        className: "theme-negro-grafito",
        swatch: "#374151",
        colors: {
            primary: "#374151",
            primaryLight: "#374151",
            primaryMid: "#111827",
            primaryDark: "#030712",
        },
    },
];

/** Backend `template` → theme id */
export const TEMPLATE_ID_TO_THEME = {
    0: "azul",
    1: "naranja",
    2: "azul-marino",
    3: "bronce",
    4: "negro-grafito",
    5: "verde",
    6: "naranja-quemado",
    7: "verde-bosque",
    8: "petroleo",
    9: "ambar",
    10: "terracota",
    11: "bordo",
    12: "fucsia",
    13: "rojo-clasico",
    14: "lima",
    15: "violeta",
    16: "turquesa",
    17: "coral",
    18: "marron-cafe",
};

export const getThemeById = (themeId) =>
    POLKISTA_THEMES.find((theme) => theme.id === themeId) ?? POLKISTA_THEMES[0];

export const getThemeClassByTemplateId = (templateId) => {
    const themeId = TEMPLATE_ID_TO_THEME[templateId] ?? "azul";
    return getThemeById(themeId).className;
};
